import React, { useEffect, useRef, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { ReactComponent as CopyIcon } from '../../../../assets/images/copy.svg';
import { api } from '../../../api';
import { showToast } from '../../../ui/utils';
import { StoredOffer } from '../components/OfferForm/offerFormLogic';

export function DuplicateButton({ offerId }: { offerId: number }) {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const mountedRef = useRef(true);

  useEffect(() => () => {
    mountedRef.current = false;
  }, []);

  const handleDuplicateClick = () => {
    setIsLoading(true);
    api.get<{ offer: StoredOffer }>(`/v1/offers/${offerId}`)
      .then((response) => {
        if (!mountedRef.current) return;
        history.push('/offers/new', { duplicateOffer: response.data.offer });
      })
      .catch(() => {
        if (!mountedRef.current) return;
        showToast({
          textMessage: 'There was an issue when duplicating your offer, please try again later or contact support.',
          timeout: 20000,
        });
        setIsLoading(false);
      });
  };

  return (
    <Button
      onClick={handleDuplicateClick}
      variant="secondary"
      size="sm"
      className="mx-1"
      disabled={isLoading}
      title="Duplicate"
    >
      {isLoading ? (
        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
      ) : (
        <CopyIcon className="btnImg" />
      )}
    </Button>
  );
}
